import { combineReducers } from 'redux'
import documentReducer from './document/DocumentReducer'
import imageReducer from './image/ImageReducer'
import textboxReducer from './textbox/TextboxReducer'
import sketchReducer from './sketch/SketchReducer'
import notificationReducer from './notification/NotificationReducer'
import profileReducer from './profile/ProfileReducer'
import overviewReducer from './overview/OverviewReducer'

import userReducer from './user/UserReducer'
import uiReducer from './ui/UiReducer'

const rootReducer = combineReducers({
  user: userReducer,
  ui: uiReducer,
  overview: overviewReducer,
  document: documentReducer,
  notifications: notificationReducer,
  image: imageReducer,
  textbox: textboxReducer,
  profile: profileReducer,
  sketch: sketchReducer,
})

export default rootReducer
